// The archived copy of a bought document, fetched through the same access the
// My Documents page uses: this browser's visitor id and remembered archive
// ids, plus the user's session when signed in — so a notification mirrored
// to the account re-downloads on any device.
import { getVisitorId } from "./trackPageView";
import { isNative } from "./nativeHttp";
import { nativeSaveBlob } from "./nativeSave";
import { userHeaders } from "./userAuth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function archivedFileUrl(docId) {
  const p = new URLSearchParams();
  const vid = getVisitorId();
  if (vid) p.set("visitorId", vid);
  try {
    const ids = JSON.parse(localStorage.getItem("ms:docIds") || "[]");
    if (Array.isArray(ids) && ids.length) p.set("ids", ids.slice(-100).join(","));
  } catch {}
  return `${BACKEND_URL}/api/my-documents/${encodeURIComponent(docId)}/download?${p.toString()}`;
}

export async function fetchArchivedFile(docId) {
  const res = await fetch(archivedFileUrl(docId), { headers: userHeaders() });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.detail || `HTTP ${res.status}`);
  }
  return res.blob();
}

export function saveBlob(blob, fileName = "document") {
  if (isNative) {
    // the WebView ignores anchor downloads: share sheet instead
    nativeSaveBlob(blob, fileName);
    return;
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = fileName;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
